import { render } from "./Solutions.vue?vue&type=template&id=2e005656"
import script from "./Solutions.vue?vue&type=script&lang=js"
export * from "./Solutions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__